import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { CheckoutItemType } from 'types/checkoutItem'
import { HorizontalLine, Spacer } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getBreads } from 'reducks/bread/selectors'
import { findBreadShortName } from 'lib/helper'
import { TimeSaleTag } from '../../Tag'

type Props = {
  isGift: boolean
  items: CheckoutItemType[]
  sender_name: string
}

const DeliveryOrderCardBodyItems: FC<Props> = (props) => {
  const { isGift, items, sender_name } = props
  const breads = useSelector((state: State) => getBreads(state))

  return (
    <ul className={styles.order__body__items}>
      {items
        .filter((item) => item.quantity !== 0) // 引当在庫数判定の改修によりquantityが0の場合もありえるが非表示とする
        .map((item, index) => (
          <li key={item.bread_ref.id}>
            <div className={styles.order__body__item}>
              <div>
                <p className={styles.order__body__item__name}>
                  {findBreadShortName(breads, item.bread_name, item.bread_ref)}
                  {item.original_price && item.original_price !== item.price && <TimeSaleTag tagName={'セール'} />}
                </p>
                {item.choice !== '' && <p className={styles.order__body__item__description}>{item.choice}</p>}
                {isGift && (
                  <p className={styles.order__body__item__description}>
                    ギフト希望
                    <br />
                    （贈り主名 : {sender_name}）
                  </p>
                )}
              </div>
              <div className={styles.order__body__item__quantity}>{item.quantity}個</div>
            </div>
            {items.length !== index + 1 && <HorizontalLine verticalMargin={0} />}
          </li>
        ))}
    </ul>
  )
}

export default DeliveryOrderCardBodyItems
